<template>
    <el-row :gutter="3">
      <el-col v-for="item in devs" :key="item.ID" :span="8" style="height: 250px; padding: 22px; border: 1px solid #909399;">
        <el-row :span="24"><b>KEY: <br/></b>{{ item.key }}</el-row>
        <el-row :span="24"></el-row>
        <el-row :span="24"><b>SECRET: <br/></b>{{ item.secret }}</el-row>
      </el-col>
      <el-col :span="8" style="height: 250px; padding: 22px; display: flex; align-items: center; justify-content: center; border: 1px solid #909399;"><button style="font-size: 56px; color: dodgerblue; background-color: #ffffff; border: none;" @click="applyshopdev"><i class="fa fa-plus-circle"></i></button></el-col>
    </el-row>
</template>

<script>
export default {
  name: 'dev',
  data () {
    return {
      devs: []
    }
  },
  mounted () {
    this.loadShopDeveloper()
  },
  methods: {
    hasloaded: function () {
      this.load.close()
      this.load = ''
    },
    fullLoad () {
      this.load = this.$loading({
        lock: true,
        text: '请求处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    applyshopdev: function () {
      var para = {}
      para.method = 'shop.applydeveloper'
      var that = this
      that.fullLoad()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.hasloaded()
        if (ret.body.code === 200) {
          that.$message.success('新的开发者生成成功')
          that.loadShopDeveloper()
        } else {
          that.$alert('新的开发者生成失败，请销后重试!')
        }
      })
    },
    loadShopDeveloper: function () {
      var that = this
      var para = {}
      para.method = 'shop.shopdevpage'
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.devs = ret.body.data
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/merchant/dev.vue